import React from 'react'

const ViewProject = () => {
    return (
        <div>
            <div className="modal fade" id="viewBrokerModal" tabindex="-1" aria-labelledby="vieweadModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-white">
                            <h5 className="section-title" id="infoBrokerModalLabel">Broker Information</h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="information-section">
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Name</label>
                                        <p id="infoName">John Doe</p> {/* Replace with dynamic data */}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Mobile No</label>
                                        <p id="infoMobile">123-456-7890</p> {/* Replace with dynamic data */}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Firm Name</label>
                                        <p id="infoFirmName">ABC Brokers</p> {/* Replace with dynamic data */}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Brokerage per</label>
                                        <p id="infoBrokerage">10%</p> {/* Replace with dynamic data */}
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label">Remarks</label>
                                        <p id="infoRemarks">Lorem ipsum dolor sit amet.</p> {/* Replace with dynamic data */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>




        </div>
    )
}

export default ViewProject
